<template>
  <div class="renovate-apply-record-bd tb" v-if="funcView.stock_renovate_apply_record_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出 -->
        <!-- <el-form-item style="float: right; margin-right: 0" v-if="funcView.scrapRecord_export">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click.native="exportTable('deviceScrapExport', formSearch)"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item> -->
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right;">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('crm_renovateApplyRecord.shen_qing_dan_hao')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('crm_renovateApplyRecord.chan_pin_xing_hao')">
            <custom-select
              url="productCodeSelectList"
              v-model="formSearch.productCode"
              :props="{ label: 'productCode', value: 'productCode' }"
              width="100%"
            ></custom-select>
          </el-form-item>

          <el-form-item :label="$t('crm_renovateApplyRecord.shen_qing_ri_qi')">
            <custom-date-picker
              v-model="formSearch.timer"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              init-Value="dateInit"
              :picker-options="pickerOptionDisAfter"
              style="width: 100%"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('crm_renovateApplyRecord.sqrsszz')">
            <el-input v-model="formSearch.applyOrgName" style="width:100%;"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
         :slots="['applyCode','action']"
      >
        <template v-slot:applyCode="scope">
          <div
            v-if="funcView.stock_renovate_apply_record_preview"
            class="cell-link"
            @click="seeBtn(scope.row)"
          >
            {{ scope.row.applyCode }}
          </div>
          <span v-else>{{ scope.row.applyCode }}</span>
        </template>
        <template slot="action" slot-scope="scope">
          <!-- <el-button type="text" size="mini" @click="seeBtn(scope.row)" v-if="funcView.stock_renovate_apply_record_preview &&(scope.row.approvalState === 10 || scope.row.approvalState === 90) ">{{funcView.stock_renovate_apply_record_preview}}</el-button> -->
          <el-button type="text" size="mini" @click="onRevoke(scope.row)" v-if="funcView.stock_renovate_apply_record_revoke &&(scope.row.approvalState=== 6)&&userInfo.rootOrgName===scope.row.applyOrgName">{{funcView.stock_renovate_apply_record_revoke}}</el-button>
          <el-button type="text" size="mini" @click="onEdit(scope.row)" v-if="funcView.stock_renovate_apply_record_edit &&(scope.row.approvalState=== 1|| scope.row.approvalState === 90)&&userInfo.rootOrgName===scope.row.applyOrgName">{{funcView.stock_renovate_apply_record_edit}}</el-button>
          <el-button type="text" size="mini" @click="onDelete(scope.row)" v-if="funcView.stock_renovate_apply_record_delete &&(scope.row.approvalState=== 1|| scope.row.approvalState === 90)&&userInfo.rootOrgName===scope.row.applyOrgName">{{funcView.stock_renovate_apply_record_delete}}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 编辑返回结果 -->
    <device-acrap-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList"
    >
    </device-acrap-dialog>
    <!-- 查看 -->
    <approval-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      @success="getTableList"
    ></approval-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

import deviceAcrapDialog from '@/pages/crm/components/deviceAcrapDialog.vue';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';

export default {
  name: 'renovateApplyRecord',
  mixins: [resetFormSearchMixins],
  components: {
    deviceAcrapDialog,
    approvalDialog
  },
  data() {
    return {
      provide: true,
      tableCode: 'renovate_apply_record',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        timer: [],
        applyStartTime: '',
        applyEndTime: '',
        productCode: '',
        applyOrgName: '',
      },
      totalRows: null,
      tableList: [],
      dialogVisible: false,
      dialogModel: {},
      // 查看
      dialogModel1: {},
      dialogVisible1: false,
      workflowType: 'return_hq_renovate_apply',
      link: null
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {};
    },
  },
  methods: {
    getTableList() {
      this.formSearch.applyStartTime = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : '';
      this.formSearch.applyEndTime = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : '';
      this.$getJSON(apis.renovateApplyPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // onEdit(row) {
    //   this.dialogVisible = true;
    //   this.dialogModel.scrapApplyId = row.scrapApplyId;
    // },
    // seeBtn(row) {
    //   this.dialogModel1.type = 'watch';
    //   this.dialogModel1.changeType = row.workflowType;
    //   this.dialogModel1.changeId = row.scrapApplyId;
    //   this.dialogVisible1 = true;
    // },
    // 查看
    seeBtn(row) {
      this.jump('/examine/approvalDetail', {
        workflowType: this.workflowType,
        bizId: row.applyId,
        showProcess: true,
      });
    },
    // 编辑申请翻新
    onEdit(row) {
      this.dialogModel1 = {
        changeId: row.applyId,
        row: this.selectedData,
        type: 'edit',
        changeType: this.workflowType,
        // changeId: this.selectedData.orderId
      };
      this.dialogVisible1 = true;
    },
    // 撤销
    onRevoke(row) {
      const { applyId } = row;
      const tips = this.$t('crm_renovateApplyRecord.nqdycxxzdspxxm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.apsApproveApprovalApproveRevoke}/${this.workflowType}/${applyId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.i18n.com_handle_success,
          });
          this.getTableList();
        });
      });
    },
    // 删除
    onDelete: function (row) {
      const tips = this.$t('crm_renovateApplyRecord.nqdyscdqxzdfxjlm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.renovateApplyDelete}/${row.applyId}`).then(
            () => {
              this.$message({
                message: this.i18n.com_handle_success,
                type: 'success',
              });
              this.getTableList();
            }
          );
        })
        .catch(() => {});
    },

  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },
  activated() {
    this.getTableList();
  },

};
</script>

<style></style>
